import React from 'react';
import { Chip } from '@mui/material';

export default function JobStatusBadge({ status }) {
  if (!status) {
    return <Chip label="No runs" size="small" variant="outlined" />;
  }

  const getStatusProps = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return { color: 'success', label: 'Completed' };
      case 'running':
        return { color: 'info', label: 'Running' };
      case 'failed':
        return { color: 'error', label: 'Failed' };
      case 'cancelled':
        return { color: 'warning', label: 'Cancelled' };
      default:
        return { color: 'default', label: status || 'Unknown' };
    }
  };

  const { color, label } = getStatusProps(status);

  return (
    <Chip 
      label={label} 
      size="small" 
      color={color}
      variant="filled"
    />
  );
}
